import CsvLineupInterface from './csv-lineup-interface';
import CsvPlayerInterface from '../player-view/csv-player-interface';

class CsvLineup implements CsvLineupInterface {
    constructor(
        private lineupNumber: number,
        private entryId: number,
        private details: any[],
        private players: CsvPlayerInterface[],
    ) {}

    getLineupNumber(): number {
        return this.lineupNumber;
    }

    getEntryId(): number {
        return this.entryId;
    }

    getDetails(): any[] {
        return [...this.details];
    }

    getPlayers(): CsvPlayerInterface[] {
        return this.players;
    }
}

export default CsvLineup;
